import { useRef } from 'react';
import { Helmet } from 'react-helmet-async';
import {
  Container,
} from '@mui/material';

import { useTranslation } from 'react-i18next';

import List from 'components/List2';

import { getContractsProvider } from 'services/requests/contract';
import { setMask } from 'utils';
import { useNavigate } from 'react-router-dom';
import * as dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);

export default function ContractsProvider() {
  const { t } = useTranslation('common');
  const listRef = useRef(null);
  const navigate = useNavigate();

  const listConfig = {
    placeholderFilter: t('contracts.search'),
    onClick: row => navigate(`/contratos/detalhe/${row.id}`),
    fields: [
      { key: 'number', label: 'Nº', desktopColumnSize: 1, isPrimary: true },
      { key: 'name', label: 'Cliente', desktopColumnSize: 3 },
      { key: 'goal', label: 'Objetivo', desktopColumnSize: 3, sm_prefix: 'Objetivo: ' },
      { key: 'amount', label: 'Valor pactuado', desktopColumnSize: 2, customValue: row => setMask('money', row.amount) },
      { key: 'installments', label: 'Parcelas', desktopColumnSize: 2, customValue: row => row.installments },
    ]
  }

  return (
    <>
      <Helmet>
        <title> {t('contractsProvider.pageTitle')} | { process.env.REACT_APP_PROJECT_NAME } </title>
      </Helmet>

      <Container>
        <List
          config={listConfig}
          getData={(params) => getContractsProvider({
            ...params,
            status: 'active'
          })}
          parseData={({ id, number, name, goal, amount, installmentscount, installmentspayed, status }) => ({
            id, number, name, goal, amount, status,
            installments: `Pagas ${installmentspayed}/${installmentscount}`,
            statusLabel: t(`contracts.status.${status}`),
            statusColor: status === 'created' ? 'info' : status === 'pendingSign' || status === 'signed' || status === 'borrowed' ? 'warning' : status === 'cancelled' ? 'error' : 'success'
          })}
          ref={listRef}
        />
      </Container>
    </>
  )
}
